import { type TabItem } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { InfoTabIcon } from '@components/_atoms/icons';
import TabbedInfoCard from '@components/_molecules/InfoCards/TabbedInfoCard';
import { type RequestProps } from '../models/RequestProps';
import { RequestDetailsTab } from './components/RequestDetailsTab';

export function RequestInfoCard({ request }: RequestProps): ReactNode {
    const tabItems: TabItem[] = [
        {
            name: 'Details',
            icon: <InfoTabIcon />,
            content: <RequestDetailsTab request={request} />,
        },
    ];

    return <TabbedInfoCard tabItems={tabItems} />;
}
